let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5UA41")]).then(() => parcelRequire('aozTf'));